import { NotifyHelper } from "../../../helpers/toast";
import { eCongThucTinhDiemSubActionObj } from "../../action-types/category/ICongThucTinhDiemSubActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const congThucTinhDiemSubActions = {
    ...generateActions(eCongThucTinhDiemSubActionObj, "CONG_THUC_TINH_DIEM_SUB"),
    ...generateActionForKey(eCongThucTinhDiemSubActionObj, "CONG_THUC_TINH_DIEM_SUB", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eCongThucTinhDiemSubActionObj, "CONG_THUC_TINH_DIEM_SUB", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eCongThucTinhDiemSubActionObj, "CONG_THUC_TINH_DIEM_SUB", "SAVE_ERROR", (m) => { NotifyHelper.Error(m.data) }),
    //...generateActionForKey(eCongThucTinhDiemSubActionObj, "CONG_THUC_TINH_DIEM_SUB", "DELETE_ERROR", (m) => { NotifyHelper.Error(m.data) }),
}